import React, { useEffect, useState, useContext } from "react";
import "../index.css";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { ProductContext } from "../context/AppContext";
import axios from 'axios';
import Footer from './Common_Components/Footer';
import translations from "./translation";

function Plans() {

    const location = useLocation();
    const [activePage, setActivePage] = useState("");
    const navigate = useNavigate();
    const day = location.state?.day || "Day Module";
    const { languageData, username } = useContext(ProductContext);
    const authToken = localStorage.getItem("AuthToken");
    const selectedLanguage = localStorage.getItem("selectedLanguage") || "hindi";
    const localTranslations = translations[selectedLanguage === "hindi" ? "hindi" : "english"];
    const [plans, setPlans] = useState([]);
    const [isSubscriptionEmpty, setIsSubscriptionEmpty] = useState(false);
    const [activeSubscription, setActiveSubscription] = useState(null);
    const [upcomingSubscriptions, setUpcomingSubscriptions] = useState([]);
    const [upcomingSlide, setUpcomingSlide] = useState(0);
    const [orderId, setOrderId] = useState(null);
    const [key, setKey] = useState(null);
    const [price, setPrice] = useState('');
    const [planId, setPlanId] = useState('');
    const { Translate } = useContext(ProductContext);
    const [expandedPlanId, setExpandedPlanId] = useState(null);


    console.log("Mobile Number", username?.message.userDetails.phone_number);
    console.log("Email", username?.message.userDetails.email);

    const ContactNumber = username?.message.userDetails.phone_number;
    const ContactEmail = username?.message.userDetails.email;

    console.log("Mobile Number", username?.message.userDetails.phone_number);
    console.log("Email", username?.message.userDetails.email);

    console.log("ContactNumber", ContactNumber);
    console.log("ContactEmail", ContactEmail);
    const toggleExpand = (id) => {
        setExpandedPlanId(expandedPlanId === id ? null : id);
    };

    const formatCurrency = (amount) => {
        const value = Number(amount);
        if (Number.isNaN(value)) return amount;
        return `₹ ${value.toFixed(3)}`;
    };

    const getPlanInfoText = (plan) => {
        const amount = Number(plan?.price);

        if (Number.isNaN(amount)) {
            return plan?.description || "";
        }

        const transactionFee = Math.ceil(amount * 0.02 * 1.18);
        const baseFee = amount - transactionFee;

        return [
            `1. ${Translate?.message?.data?.fullPrice || "Full Price"} ~ ${formatCurrency(amount)}`,
            `2. ${Translate?.message?.data?.transactionCost || "Transaction Cost + GST on transaction cost"} ~ ${formatCurrency(transactionFee)}`,
            `3. ${Translate?.message?.data?.appUsageFee || "App usage fee"} ~ ${formatCurrency(baseFee)} INR`,
            `4. ${Translate?.message?.data?.futureGstNote || "Future GST note ~ If the company enters the GST tax bracket, an additional 18% GST will be charged and the transaction cost will increase accordingly."}`,
        ];
    };

    useEffect(() => {
        const getPayment = async () => {
            try {
                const response = await axios.get(`https://api.japaking.online/api/subscription-plan`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                });

                if (response.data.success) {
                    const sortedPlans = [...response.data.message.plans].sort((a, b) => {
                        const durationA = Number(a.duration_in_days) || 0;
                        const durationB = Number(b.duration_in_days) || 0;
                        return durationA - durationB;
                    });
                    setPlans(sortedPlans);
                }
            } catch (error) {
                console.log("error getting payment ", error);
            }
        };
        getPayment();
    }, []);

    useEffect(() => {
        const getActivity = (p) => p.Activity_Status ? String(p.Activity_Status).toLowerCase() : "";
        const isActiveStatus = (p) => ["active", "trial", "trail"].includes(getActivity(p));

        const applyUserPlans = (userPlans) => {
            if (!Array.isArray(userPlans) || userPlans.length === 0) {
                setActiveSubscription(null);
                setUpcomingSubscriptions([]);
                setIsSubscriptionEmpty(true);
                return;
            }
            const now = new Date();
            const byStartDate = (a, b) => new Date(a.start_date) - new Date(b.start_date);
            const sortedPlans = [...userPlans].sort(byStartDate);

            // Prefer backend Activity_Status; fall back to date range
            const activeSub = sortedPlans.find(isActiveStatus) ||
                sortedPlans.find(p => new Date(p.start_date) <= now && new Date(p.end_date) >= now && p.status === "active");
            setActiveSubscription(activeSub || null);
            setIsSubscriptionEmpty(!activeSub);

            // Every other queued plan: marked Active by backend, or starting in the future
            const upcoming = sortedPlans.filter(p =>
                p.id !== (activeSub ? activeSub.id : null) &&
                p.status === "active" &&
                (isActiveStatus(p) || new Date(p.start_date) > now)
            );
            setUpcomingSubscriptions(upcoming);
        };

        const getUserSubscription = async () => {
            try {
                const response = await axios.get(`https://api.japaking.online/api/user-subscription`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                });

                const userPlans = response?.data?.message?.plan;
                applyUserPlans(userPlans);
            } catch (error) {
                console.log("error getting user subscription ", error);
                const userPlans = error?.response?.data?.message?.plan;
                applyUserPlans(userPlans);
            }
        };

        getUserSubscription();
    }, [authToken]);

    useEffect(() => {
        if (orderId && key && price) {
            openRazorpayCheckout();
        }
    }, [orderId, key, price]);

    const loadRazorpayScript = () => {
        return new Promise((resolve, reject) => {
            if (typeof window !== 'undefined' && !window.Razorpay) {
                const script = document.createElement('script');
                script.src = 'https://checkout.razorpay.com/v1/checkout.js';
                script.onload = () => resolve(true);
                script.onerror = () => reject(new Error("Razorpay SDK failed to load"));
                document.head.appendChild(script);
            } else {
                resolve(true);
            }
        });
    };

    const handlePayment = async (id, price) => {
        try {
            const keyResponse = await axios.get(`https://api.japaking.online/api/payment/key`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (keyResponse.data.message && keyResponse.data.message.data) {
                setKey(keyResponse.data.message.data.key);
            } else {
                console.log("Error: key not found in response");
            }
        } catch (error) {
            console.log("error getting key ", error);
        }

        setPrice(price);
        setPlanId(id);

        try {
            const orderResponse = await axios.post(`https://api.japaking.online/api/payment`, {
                planId: id
            }, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                }
            });

            const data = orderResponse.data;
            if (data.message) {
                const paymentRes = data.message.paymentRes;
                setOrderId(paymentRes.id);
            } else {
                console.log("Payment not successful");
            }
        } catch (error) {
            console.log("error in checkOut", error);
        }
    };

    const openRazorpayCheckout = async () => {
        try {
            await loadRazorpayScript();

            const options = {
                description: 'Credits towards consultation',
                image: `${process.env.PUBLIC_URL}/assets/images/paylogo.png`,
                currency: 'INR',
                key: key,
                amount: price,
                name: 'Erish',
                order_id: orderId,
                prefill: {
                    // email: 'Support@erishsolutions.com111',
                    // contact: '+916546643534',
                    name: 'nitessh',
                },
                theme: { color: '#ffc0cb' },
                handler: async (response) => {
                    console.log('Payment successful:', response);

                    if (response && response.razorpay_payment_id) {
                        try {
                            const validateRes = await axios.post(
                                `https://api.japaking.online/api/payment/verify`,
                                {
                                    razorpay_order_id: response.razorpay_order_id,
                                    razorpay_payment_id: response.razorpay_payment_id,
                                    razorpay_signature: response.razorpay_signature,
                                    planId: planId,
                                },
                                {
                                    headers: {
                                        "Content-Type": "application/json",
                                        Authorization: `Bearer ${authToken}`,
                                    },
                                }
                            );

                            console.log('Validation response:', validateRes.data);
                            navigate('/');
                        } catch (error) {
                            console.error('Error during validation:', error);
                        }
                    } else {
                        console.log('Invalid or missing payment data.');
                    }
                },
                modal: {
                    confirm_close: true, // Show confirmation on close
                },
            };

            const razorpay = new window.Razorpay(options);
            razorpay.open();

            razorpay.on('payment.failed', (response) => {
                console.log('Payment failed:', response.error);
            });
        } catch (error) {
            console.error('Error loading Razorpay script or opening checkout:', error);
        }
    };

    const getCurrentPlanName = (planId) => {
        const found = plans.find(p => p.id === planId);
        return found ? found.name : "Active Plan";
    };

    const getDaysLeftText = (endDateStr) => {
        if (!endDateStr) return "";
        const endDate = new Date(endDateStr);
        const today = new Date();
        const diffTime = endDate.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays <= 0) return localTranslations?.expired || "Expired";
        return localTranslations?.daysLeft ? localTranslations.daysLeft.replace("{days}", diffDays) : `${diffDays} Days Left`;
    };

    const formatExpiryDate = (dateStr) => {
        if (!dateStr) return "";
        try {
            const date = new Date(dateStr);
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            return `${yyyy}/${mm}/${dd}`;
        } catch {
            return "";
        }
    };

    const getDurationInDays = (start, end) => {
        if (!start || !end) return 0;
        const startDate = new Date(start);
        const endDate = new Date(end);
        const diffTime = endDate.getTime() - startDate.getTime();
        return Math.round(diffTime / (1000 * 60 * 60 * 24));
    };

    return (
        <div className='Profile_Design_Main_Div_11'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />
                            <h2>{Translate?.message?.data?.Plans || localTranslations?.payment || "Plans"}</h2>
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className='logo_1' style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="plans-tiles-container">
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-md-8 col-lg-6'>
                            <div>
                                {isSubscriptionEmpty && (
                                    <h4 style={{ textAlign: 'center', color: '#ff4d4d', marginBottom: '20px', fontWeight: 'bold' }}>
                                        {Translate?.message?.data?.noCredits || "No credits left, pay to study"}
                                    </h4>
                                )}

                                {activeSubscription && (
                                    <div
                                        style={{
                                            background: "#ffffff",
                                            border: "1px solid #e6e6ea",
                                            borderRadius: "18px",
                                            padding: "20px",
                                            marginBottom: "24px",
                                            boxShadow: "0 2px 10px rgba(15, 15, 15, 0.04)",
                                            textAlign: "left"
                                        }}
                                    >
                                        <h3 style={{ margin: "0 0 16px 0", fontSize: "18px", fontWeight: "bold", color: "#151515" }}>
                                            {Translate?.message?.data?.currentPlan || localTranslations?.currentPlan || "Current Active Plan"}
                                        </h3>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <div>
                                                <strong style={{ fontSize: "16px", color: "#007BFF" }}>
                                                    {getCurrentPlanName(activeSubscription.subscription_plan_id)}
                                                </strong>
                                                <div style={{ fontSize: "13px", color: "#787878", marginTop: "4px" }}>
                                                    {Translate?.message?.data?.expiresOn || localTranslations?.expiresOn || "Expires on"}: <strong>{formatExpiryDate(activeSubscription.end_date)}</strong>
                                                </div>
                                            </div>
                                            <span style={{
                                                fontSize: "12px",
                                                fontWeight: "600",
                                                backgroundColor: "rgba(0, 123, 255, 0.08)",
                                                color: "#007BFF",
                                                padding: "4px 10px",
                                                borderRadius: "12px"
                                            }}>
                                                {getDaysLeftText(activeSubscription.end_date)}
                                            </span>
                                        </div>
                                    </div>
                                )}

                                {upcomingSubscriptions && upcomingSubscriptions.length > 0 && (
                                    <div
                                        style={{
                                            background: "#ffffff",
                                            border: "1px solid #e6e6ea",
                                            borderRadius: "18px",
                                            padding: "20px",
                                            marginBottom: "24px",
                                            boxShadow: "0 2px 10px rgba(15, 15, 15, 0.04)",
                                            textAlign: "left"
                                        }}
                                    >
                                        <h3 style={{ margin: "0 0 16px 0", fontSize: "18px", fontWeight: "bold", color: "#151515" }}>
                                            {Translate?.message?.data?.upcomingPlans || localTranslations?.upcomingPlans || "Upcoming Plans"} ({upcomingSubscriptions.length})
                                        </h3>
                                        <div
                                            className="upcoming-plans-slider"
                                            onScroll={(e) => {
                                                const el = e.currentTarget;
                                                setUpcomingSlide(Math.round(el.scrollLeft / el.clientWidth));
                                            }}
                                            style={{
                                                display: "flex",
                                                overflowX: "auto",
                                                scrollSnapType: "x mandatory",
                                                scrollbarWidth: "none",
                                                WebkitOverflowScrolling: "touch"
                                            }}
                                        >
                                            {upcomingSubscriptions.map((sub, sIdx) => (
                                                <div
                                                    key={sub.id || sIdx}
                                                    style={{
                                                        flex: "0 0 100%",
                                                        boxSizing: "border-box",
                                                        scrollSnapAlign: "start",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        gap: "10px"
                                                    }}
                                                >
                                                    <div>
                                                        <strong style={{ fontSize: "16px", color: "#007BFF" }}>
                                                            {getCurrentPlanName(sub.subscription_plan_id)}
                                                        </strong>
                                                        <div style={{ fontSize: "13px", color: "#787878", marginTop: "4px" }}>
                                                            {Translate?.message?.data?.startsOn || localTranslations?.startsOn || "Starts on"}: <strong>{formatExpiryDate(sub.start_date)}</strong>
                                                        </div>
                                                        <div style={{ fontSize: "13px", color: "#787878", marginTop: "2px" }}>
                                                            {Translate?.message?.data?.expiresOn || localTranslations?.expiresOn || "Expires on"}: <strong>{formatExpiryDate(sub.end_date)}</strong>
                                                        </div>
                                                    </div>
                                                    <span style={{
                                                        fontSize: "12px",
                                                        fontWeight: "600",
                                                        backgroundColor: "rgba(0, 123, 255, 0.08)",
                                                        color: "#007BFF",
                                                        padding: "4px 10px",
                                                        borderRadius: "12px"
                                                    }}>
                                                        {getDurationInDays(sub.start_date, sub.end_date)} {Translate?.message?.data?.days || localTranslations?.days || "Days"}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                        {upcomingSubscriptions.length > 1 && (
                                            <div style={{ display: "flex", justifyContent: "center", gap: "6px", marginTop: "12px" }}>
                                                {upcomingSubscriptions.map((sub, dIdx) => (
                                                    <span
                                                        key={sub.id || dIdx}
                                                        onClick={(e) => {
                                                            const slider = e.currentTarget.parentElement.previousElementSibling;
                                                            slider.scrollTo({ left: dIdx * slider.clientWidth, behavior: "smooth" });
                                                        }}
                                                        style={{
                                                            width: upcomingSlide === dIdx ? "18px" : "8px",
                                                            height: "8px",
                                                            borderRadius: "4px",
                                                            backgroundColor: upcomingSlide === dIdx ? "#007BFF" : "#cfd8e3",
                                                            cursor: "pointer",
                                                            transition: "all 0.2s"
                                                        }}
                                                    />
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )}
                                {plans.map((plan, idx) => {
                                    const isExpanded = expandedPlanId === plan.id;
                                    const oneMonthPlan = plans.find(p => Number(p.duration_in_days) === 30);
                                    const basePrice = oneMonthPlan ? Number(oneMonthPlan.price) : 2049.00;
                                    const duration = Number(plan.duration_in_days) || 0;
                                    const currentPrice = Number(plan.price) || 0;
                                    const monthsCount = Math.round(duration / 30);
                                    const isMultiMonth = monthsCount > 1;
                                    const originalPrice = basePrice * monthsCount;
                                    const hasDiscount = isMultiMonth && originalPrice > currentPrice;
                                    const discountAmount = originalPrice - currentPrice;
                                    const discountPercent = hasDiscount ? Math.round((discountAmount / originalPrice) * 100) : 0;
                                    const pricePerMonth = monthsCount > 0 ? (currentPrice / monthsCount) : currentPrice;

                                    return (
                                        <div
                                            key={idx}
                                            className="plans-content"
                                            style={{ marginBottom: '10px' }}
                                        >
                                            <div className="plans-content-header" style={{ alignItems: 'stretch' }} onClick={() => toggleExpand(plan.id)}>
                                                <div className="plans-header-info">
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', marginBottom: '8px' }}>
                                                        <h2 style={{ margin: 0, fontSize: '22px', color: '#007BFF', fontWeight: 'bold' }}>
                                                            {plan.name}
                                                        </h2>
                                                        <span style={{
                                                            fontSize: '12px',
                                                            fontWeight: '700',
                                                            backgroundColor: 'rgba(0, 123, 255, 0.15)',
                                                            color: '#007BFF',
                                                            padding: '4px 10px',
                                                            borderRadius: '20px',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px'
                                                        }}>
                                                            {plan.duration_in_days} {Translate?.message?.data?.Days || localTranslations?.days || "Days"}
                                                        </span>
                                                    </div>
                                                    {hasDiscount ? (
                                                        <div style={{ margin: '5px 0' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                                <span style={{ textDecoration: 'line-through', color: '#777', fontSize: '15px' }}>
                                                                    ₹ {originalPrice.toFixed(2)}
                                                                </span>
                                                                <span style={{ fontSize: '20px', fontWeight: 'bold', color: '#111' }}>
                                                                    ₹ {currentPrice.toFixed(2)}
                                                                </span>
                                                                <span style={{ backgroundColor: '#28a745', color: '#fff', fontSize: '11px', fontWeight: 'bold', padding: '2px 6px', borderRadius: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                                    {discountPercent}% {Translate?.message?.data?.off || localTranslations?.off || "OFF"}
                                                                </span>
                                                            </div>
                                                            <div style={{ color: '#28a745', fontSize: '14px', fontWeight: 'bold', marginTop: '4px' }}>
                                                                {Translate?.message?.data?.save || localTranslations?.save || "Save"} ₹ {discountAmount.toFixed(2)}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <p style={{ fontSize: '20px', fontWeight: 'bold', color: '#111', margin: '5px 0' }}>
                                                            ₹ {Number(plan.price).toFixed(2)}
                                                        </p>
                                                    )}
                                                    <p style={{ fontSize: '15px', color: '#555', margin: '5px 0', fontWeight: '600' }}>
                                                        ₹ {Math.round(pricePerMonth)}{Translate?.message?.data?.monthly || localTranslations?.monthly || "/monthly"}
                                                    </p>
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', paddingLeft: '15px' }}>
                                                    <div className="plans-expand-arrow" style={{ paddingLeft: 0, marginTop: '2px' }}>
                                                        {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                    </div>
                                                    <button
                                                        style={{
                                                            backgroundColor: '#000',
                                                            color: '#fff',
                                                            border: 'none',
                                                            borderRadius: '20px',
                                                            padding: '6px 14px',
                                                            fontSize: '12px',
                                                            fontWeight: 'bold',
                                                            cursor: 'pointer',
                                                            whiteSpace: 'nowrap',
                                                            boxShadow: '0 2px 5px rgba(0,0,0,0.25)',
                                                            marginBottom: '2px'
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handlePayment(plan.id, plan.price);
                                                        }}
                                                    >
                                                        {Translate?.message?.data?.payNow || localTranslations?.payNow || "Pay Now"}
                                                    </button>
                                                </div>
                                            </div>

                                            {isExpanded && (
                                                <div className="plans-expanded-body">
                                                    <div className="plans-card-divider"></div>
                                                    <p style={{ whiteSpace: 'pre-line', lineHeight: '1.6', color: '#555', fontSize: '16px' }}>
                                                        {getPlanInfoText(plan).join("\n")}
                                                    </p>
                                                    <button
                                                        className="plans-pay-button"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handlePayment(plan.id, plan.price);
                                                        }}
                                                    >
                                                        {isSubscriptionEmpty ? (Translate?.message?.data?.clickToPay || "Click to pay") : (Translate?.message?.data?.proceedToPay || "Proceed to Pay")}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Plans;
